module.exports = __webpack_public_path__ + "static/media/email.8f4b213e.png";